import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export default function SelectionSingleSelectItem(props) {
  const {
    label,
    selected = false,
    disabled = false,
    onChange = () => {},
  } = props;
  const stateClass = selected
    ? 'bg-cs-orange-100 border-cs-orange-500'
    : 'bg-white border-gray-300';

  const indicatorClass = selected
    ? 'size-4 rounded-full bg-cs-orange-500 border border-cs-orange-400'
    : 'size-4 rounded-full bg-white border border-gray-300';

  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      disabled={disabled}
      onClick={onChange}
      className={classNames(
        'inline-flex items-start gap-[6px] p-[10px] rounded-[10px] border transition-colors text-left',
        'text-base leading-[1.5] tracking-[-0.17px] text-gray-700',
        'active:bg-cs-orange-100 active:border-cs-orange-500',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2',
        'hover:border-cs-orange-500 hover:bg-cs-orange-50',
        stateClass,
        disabled ? 'opacity-40 cursor-not-allowed pointer-events-none' : 'cursor-pointer',
      )}
    >
      <span className="flex items-center h-6 flex-shrink-0" aria-hidden="true">
        <span className={indicatorClass} />
      </span>
      <span>{label}</span>
    </button>
  );
}

SelectionSingleSelectItem.propTypes = {
  label: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};
